__turbopack_context__.v({
  "className": "cormorant_garamond_6e880b6-module__IjkQ1q__className",
});
